import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, RefObject } from 'react';
import { CfSearchInput } from '../../../SearchInput/CfSearchInput';
import { KeyboardNavigator } from '../../utility/keyboard-navigation';

export interface CfDataGridFilterProps {
  keyboardNavigator: KeyboardNavigator;
  filterText?: string;
  filterPlaceholderText?: string;
  onChange: (filterText?: string) => void;
  testId?: string;
  searchButtonTestId?: string;
  inputRef?: RefObject<HTMLInputElement>;
  sx?: SxProps<Theme>;
  isResponsive?: boolean;
}

export const CfDataGridFilter: FC<CfDataGridFilterProps> = (props: CfDataGridFilterProps) => {
  const handleOnChange = (filterText?: string) => {
    if (filterText !== props.filterText) props.onChange(filterText);
  };
  return (
    <CfSearchInput
      inputRef={props.inputRef}
      initialValue={props.filterText}
      onSubmit={handleOnChange}
      onClear={() => props.onChange('')}
      onKeyDown={(event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          props.keyboardNavigator.firstEnabledElement?.focus();
        }
      }}
      placeholder={props.filterPlaceholderText ?? 'Filter'}
      sx={{ width: 394, ...props.sx }}
      testId={props.testId}
      searchButtonTestId={props.searchButtonTestId}
      isResponsive={props.isResponsive}
    />
  );
};
